// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer___1C8BN","footer__flow":"footer__flow___2NQgX","footer__contact":"footer__contact___3Aq9U","footer__hiring__button":"footer__hiring__button___apk_N","footer__tel":"footer__tel___3a3ug","footer__email":"footer__email___2WGCC","footer__social":"footer__social___18yZj"};
    if(module.hot) {
      // 1677682834794
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  